import { render, staticRenderFns } from "./cn_noData.vue?vue&type=template&id=45c4c67b&scoped=true&"
import script from "./cn_noData.vue?vue&type=script&lang=js&"
export * from "./cn_noData.vue?vue&type=script&lang=js&"
import style0 from "./cn_noData.vue?vue&type=style&index=0&id=45c4c67b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c4c67b",
  null
  
)

export default component.exports